import { render, staticRenderFns } from "./pdp.vue?vue&type=template&id=2f819734&"
import script from "./pdp.vue?vue&type=script&lang=js&"
export * from "./pdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports